import { Checkbox } from 'framework7-react';
import { ComponentProps, FC, useState } from 'react';

import { uuid } from '@utilities/uuid';

import Button from '@components/buttons/Button';
import IconButton from '@components/buttons/IconButton';
import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';

import { Input } from './Input';

interface DynamicInputItem {
  key: string;
  text: string;
}

interface DynamicInputListProps {
  addButton?: { text: string; defaultValue?: string };
  defaultItems: DynamicInputItem[];
  inputProps?: ComponentProps<typeof Input>;
  checked: (item: DynamicInputItem) => boolean;
  onCheckChange: (key: string) => void;
  onChange: (updatedItems: DynamicInputItem[]) => void;
}

export const DynamicInputList: FC<DynamicInputListProps> = ({
  addButton,
  defaultItems,
  inputProps,
  checked,
  onCheckChange,
  onChange,
}) => {
  const [items, setItems] = useState<DynamicInputItem[]>(defaultItems);

  const handleAdd = () => {
    console.log('adding');
    setItems((prev) => {
      const updated = [
        ...prev,
        {
          key: uuid(),
          text: addButton?.defaultValue ?? '',
        },
      ];

      onChange(updated);

      return updated;
    });
  };

  const handleRemove = (key: string) => {
    setItems((prev) => {
      const updated = prev.filter((item) => item.key !== key);
      onChange(updated);
      return updated;
    });
  };

  const handleInputChange = (i: number, value: string) => {
    setItems((prev) => {
      const updated = [...prev];
      updated[i] = { ...updated[i], text: value };
      onChange(updated);
      return updated;
    });
  };

  return (
    <div className="d-grid gap-2">
      {items.map((item, i) => (
        <div key={item.key} className="d-flex gap-2 align-items-center">
          <div>
            <Checkbox checked={checked(item)} onChange={() => onCheckChange(item.key)} />
          </div>
          <div className="w-100">
            <Input
              {...inputProps}
              defaultValue={item.text}
              onChange={(e) => handleInputChange(i, e.target.value)}
            />
          </div>
          <div>
            <IconButton variant="smooth" color="danger" onClick={() => handleRemove(item.key)}>
              <FontAwesomeIcon name="times" />
            </IconButton>
          </div>
        </div>
      ))}
      {addButton && (
        <div>
          <Button
            startIcon={<FontAwesomeIcon name="plus" />}
            variant="flat"
            color="neutral"
            roundness="rounded"
            onClick={() => handleAdd()}
          >
            {addButton.text}
          </Button>
        </div>
      )}
    </div>
  );
};
